import {
  MutationHookOptions,
  MutationTuple,
  QueryHookOptions,
  QueryResult,
  useLazyQuery,
  LazyQueryHookOptions,
  useQuery,
  useMutation,
  QueryTuple,
} from '@apollo/client';
import { DocumentNode } from 'graphql';

type OperationVariables = Record<string, any>;

export function useAPIQuery<TData = any, TVariables = OperationVariables>(
  query: DocumentNode,
  options?: QueryHookOptions<TData, TVariables>,
): QueryResult<TData, TVariables> {
  return useQuery<TData, TVariables>(query, { ...options });
}

export function useAPILazyQuery<TData = any, TVariables = OperationVariables>(
  query: DocumentNode,
  options?: LazyQueryHookOptions<TData, TVariables>,
): QueryTuple<TData, TVariables> {
  return useLazyQuery<TData, TVariables>(query, { ...options });
}

export function useAPIMutation<TData = any, TVariables = OperationVariables>(
  mutation: DocumentNode,
  options?: MutationHookOptions<TData, TVariables>,
): MutationTuple<TData, TVariables> {
  return useMutation<TData, TVariables>(mutation, { ...options });
}
